module.exports = __webpack_public_path__ + "img/biometric-logo-mini.3951f1ec.svg";